import Cookies from 'js-cookie'

export const getToken = () => (
  Cookies.get(process.env.SESSION_API_KEY_COOKIE_NAME)
)

export const setToken = token => (
  Cookies.set(process.env.SESSION_API_KEY_COOKIE_NAME, token, {
    expires: 365
  })
)

export const clearToken = () => (
  Cookies.remove(process.env.SESSION_API_KEY_COOKIE_NAME)
)
